import React, { useState, useEffect } from 'react';
import climatisation from './resources/img/services/climatisation.jpeg';
import restaurant from './resources/img/services/restaurant.jpeg';
import electrical from './resources/img/services/eletrical.jpeg';
import brickwall from './resources/img/brickwall.svg';
import consulting from './resources/img/consulting.jpeg';
import management from './resources/img/management.jpeg';
import hardwood from './resources/img/hardwood.jpeg';
import proyecto1 from './resources/img/proyecto1.jpeg';
import proyecto2 from './resources/img/proyecto2.jpeg';
import proyecto3 from './resources/img/proyecto3.jpeg';
import proyecto4 from './resources/img/proyecto4.jpeg';
import proyecto5 from './resources/img/proyecto5.jpeg';
import proyecto6 from './resources/img/proyecto6.jpeg';
import proyecto7 from './resources/img/proyecto7.jpeg';
import proyecto8 from './resources/img/proyecto8.jpeg';
import silhoutte from './resources/img/silhoutte.svg';
import red from './resources/img/red.svg';
import hotel from './resources/img/hotel.svg';
import fc from './resources/img/fc.svg';
import abuela from './resources/img/abuela.svg';
import chocolate from './resources/img/chocolate.svg';
import clock from './resources/img/clock.svg';
import whatsapp from './resources/img/whatsapp.svg';
import location from './resources/img/location.svg';
import mail from './resources/img/mail.svg';
import { NavLink, Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

const validate = (values) => {
  let errors = {};
  if (!values.name){
    errors.name = 'El nombre es requerido';
  } else if (!values.email) {
    errors.email = 'El email es requerido';
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = 'El email no es válido';
  } else if (!values.phone) {
    errors.phone = 'El Teléfono es requerido';
  } else if (!/^(\+34|0034|34)?[6789]\d{8}$/.test(values.phone.replace(/\s/g, ''))) {
    errors.phone = 'El número telefónico no es válido';
  } else if (!values.message) {
    errors.message = 'El mensaje está vacío';
  }
  return errors;
};

const App = () => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      sendMessage();
    }
  }, [errors]);

  const handleSubmit = (event) => {
    if (event) event.preventDefault();
    setErrors(validate(values));
    setIsSubmitting(true);
  };

  const handleChange = (event) => {
    event.persist();
    setValues(values => ({ ...values, [event.target.name]: event.target.value }));
    setErrors(errors => ({ ...errors, [event.target.name]: undefined }))
  };

  const sendMessage = () => {
    console.log('Enviando mensaje');
    setValues(() => ({}));
  }

  return (
    <div className='main-page'>
      <div className='slider'>
        <h1>Planifica tu obra.</h1>
        <h3>______ Te ayudamos a ejecutarla</h3>
      </div>
      <div className='content'>

        <div className='banner'>
          <img src={brickwall} className='mobile-hidden'/>
          <span className={'divider mobile-hidden'}></span>
          <div className='questions'>
            <small>Tienes preguntas?</small>
            <span>No dudes en contactarnos.</span>
          </div>
          <div className='actions'>
            <NavLink to='/quote'>
              <button className='budget'>Pide Presupuesto</button>
            </NavLink>
            <HashLink to="/#contact-us" scroll={(el) => el.scrollIntoView({ behavior: 'smooth' })}>
              <button className='contact'>Contáctanos</button>
            </HashLink>
          </div>
        </div>

        <div className='services'>
          <div>
            <Link to='services/1'>
              <div className={'img renovation'}></div>
              <div className={'icon renovation'}></div>
              <div className='body'>
                
                <span className='title'>Reforma integrales</span>
                <hr></hr>
                <span className='text'>
                Ofrecemos las mejores soluciones para viviendas, comunidades, locales y oficinas comerciales.<br/>
                Abarcamos todos los trabajos que pueden ser necesarios para realizar una reforma:<br/><br/>
                Albañilería y revestimientos, Solados y alicatados, Instalaciones de Fontanería y Saneamiento,
                Instalaciones eléctricas y climatización, Carpinterías de aluminio y pvc, Pladur y Pinturas,
                Instalacion de suelos en general.
                </span>
                
                  <div className='more'>
                    + <span>Saber más</span>
                  </div>
              </div>
            </Link>
          </div>
          <div>
            <Link to='services/1'>
              <div className={'img kitchen'}></div>
              <div className={'icon tiling'}></div>
              <div className='body'>
                <span className='title'>Reforma de cocinas</span>
                <hr></hr>
                <span className='text'>
                  Ofrecemos un servicio integral, abarcando desde la realización del proyecto hasta la planificación y ejecución de la obra. <br/>
                  Además, diseñaremos vuestra cocina para que os ofrezca todas las prestaciones necesarias y utilizaremos los mejores materiales
                  para garantizar unos acabados de calidad. <br/>¡Llámanos y dinos cómo quieres que sea tu cocina!
                </span>
                <div className='more'>
                  + <span>Saber más</span>
                </div>
              </div>
            </Link>
          </div>
          <div>
            <Link to='services/1'>
              <div className={'img bathroom'}></div>
              <div className={'icon design'}></div>
              <div className='body'>
                <span className='title'>Reforma de baños</span>
                <hr></hr>
                <span className='text'>
                  Aportamos soluciones integrales de máxima calidad y garantizamos unos impecables acabados. Además, realizamos desde los cambios de
                  placa de ducha hasta el mobiliario, contando para ello con un excelente equipo de especialistas, profesionales cualificados que
                  tienen mucha experiencia de trabajo en el sector.
                </span>
                <div className='more'>
                  + <span>Saber más</span>
                </div>
              </div>
            </Link>
          </div>
          <div className={'reduced mobile-hidden'}>
            <Link to='services/1'>
              <img src={climatisation} />
              <div className='body'>
                <span className='title'>Climatización</span>
                <span className='text'>
                  Después de realizar un estudio de los metros cúbicos y los cerramientos, se plantea la climatización adecuada para cada espacio, teniendo
                  en cuenta también el tipo de equipo que mejor se adapte.
                </span>
                <div className='more'>
                  + <span>Saber más</span>
                </div>
              </div>
            </Link>
          </div>
          <div className={'reduced mobile-hidden'}>
            <Link to='services/1'>
              <img src={restaurant} />
              <div className='body'>
                <span className='title'>Locales y oficinas comerciales</span>
                <span className='text'>
                  Adecuación de locales como obra nueva, garantizando en ambos casos unos excelentes resultados en todos los parámetros: aprovechamiento de 
                  los espacios, funcionalidad, estética, calidad de los acabados, etc.  
                </span>
                <div className='more'>
                  + <span>Saber más</span>
                </div>
              </div>
            </Link>
          </div>
          <div className={'reduced mobile-hidden'}>
            <Link to='services/1'>
              <img src={electrical} />
              <div className='body'>
                <span className='title'>Instalación eléctrica</span>
                <span className='text'>
                  En base al proyecto realizado, ofrecemos la instalación eléctrica y de datos según las necesidades de los puestos de trabajo, integrándolo
                  al espacio y al mobiliario. 
                </span>
                <div className='more'>
                  + <span>Saber más</span>
                </div>
              </div>
            </Link>
          </div>
          <span className='actions'>
            <NavLink to='/services'>
              <button>Servicios +</button>
            </NavLink>
          </span>
        </div>

      </div>

      <div className='latest-projects'>
        <div className='latest'>
          <div className='section'>
            <small>Conoce nuestro trabajo</small>
            <span className='title'>
              Ultimos<br></br>proyectos<strong>.</strong>
            </span>
          </div>
          <div className='explore'>
            <NavLink to='/projects'>
              <button>Proyectos +</button>
            </NavLink>
          </div>
        </div>
        <div className='projects'>
          <div>
            <span className='type'>
              <strong>Reforma integral</strong>
              <NavLink to='/projects/1'>
                <div className='more'>
                  + <span>Saber más</span>
                </div>
              </NavLink>
            </span>
            
            <div style={{background: `linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.4)), url(${proyecto1}) no-repeat center`}}></div>
          </div>
          <div>
            <span className='type'>
              <strong>Instalación de suelos</strong>
              <NavLink to='/projects/2'>
                <div className='more'>
                  + <span>Saber más</span>
                </div>
              </NavLink>
            </span>
            <div style={{background: `linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.4)), url(${proyecto2}) no-repeat center`}}></div>
          </div>
          <div>
            <span className='type'>
              <strong>Reforma cocina</strong>
              <NavLink to='/projects/3'>
                <div className='more'>
                  + <span>Saber más</span>
                </div>
              </NavLink>
            </span>
            <div style={{background: `linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5)), url(${proyecto3}) no-repeat center`}}></div>
          </div>
          <div>
            <span className='type'>
              <strong>Reforma baño</strong>
              <NavLink to='/projects/4'>
                <div className='more'>
                  + <span>Saber más</span>
                </div>
              </NavLink>
            </span>
            <div style={{background: `linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5)), url(${proyecto4}) no-repeat center`}}></div>
          </div>
          <div className='mobile-hidden'>
            <span className='type'>
              <strong>Instalación calefacción</strong>
              <NavLink to='/projects/5'>
                <div className='more'>
                  + <span>Saber más</span>
                </div>
              </NavLink>
            </span>
            <div style={{background: `linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5)), url(${proyecto5}) no-repeat center`}}></div>
          </div>
          <div className='mobile-hidden'>
            <span className='type'>
              <strong>Instalación ventanas</strong>
              <NavLink to='/projects/6'>
                <div className='more'>
                  + <span>Saber más</span>
                </div>
              </NavLink>
            </span>
            <div style={{background: `linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5)), url(${proyecto6}) no-repeat center`}}></div>
          </div>
          <div className='mobile-hidden'>
            <span className='type'>
              <strong>Pintado de piso</strong>
              <NavLink to='/projects/7'>
                <div className='more'>
                  + <span>Saber más</span>
                </div>
              </NavLink>
            </span>
            <div style={{background: `linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5)), url(${proyecto7}) no-repeat center`}}></div>
          </div>
          <div className='mobile-hidden'>
            <span className='type'>
              <strong>Instalación eléctrica</strong>
              <NavLink to='/projects/8'>
                <div className='more'>
                  + <span>Saber más</span>
                </div>
              </NavLink>
            </span>
            <div style={{background: `linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5)), url(${proyecto8}) no-repeat center`}}></div>
          </div>
        </div>
      </div>

      <div className='statistics'>
        <div>
          <strong>37</strong>
          Proyectos completados
        </div>
        <span className='divider'></span>
        <div>
          <strong>32</strong>
          Clientes satisfechos
        </div>
        <span className='divider'></span>
        <div>
          <strong>23</strong>
          Años de experiencia
        </div>
      </div>

      <div className='reasons'>
        <div className='section'>
          <small>Lo que nos distingue del resto</small>
          <span className='title'>
            ¿Por qué elegirnos?<strong>.</strong>
          </span>
        </div>
        <div className='body'>
          <div className='left'>
            <div className='reason'>
              <span className='availability'></span>
              <strong>Disponibilidad</strong>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.
            </div>
            <div className='reason'>
              <span className='price'></span>
              <strong>Precios justos</strong>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.
            </div>
          </div>
          <img src={silhoutte} />
          <div className='right'>
            <div className='reason'>
              <span className='qualified'></span>
              <strong>Trabajadores cualificados</strong>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.
            </div>
            <div className='reason'>
              <span className='quality'></span>
              <strong>La mejor calidad</strong>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.
            </div>
          </div>
        </div>
      </div>

      <div className='clients'>
        <div className='section'>
          <small>Ellos siempre confian en nosotros</small>
          <span className='title'>
            Nuestros clientes<strong>.</strong>
          </span>
        </div>
        <div className='body'>
          <img src={red} />
          <img src={fc} />
          <img src={abuela} />
          <img src={hotel} />
          <img src={chocolate} />
        </div>
      </div>

      <div className='contact' id='contact-us'>
        <div className='message'>
          <span className='title'>Envíanos un mensaje</span>
          <span className='subtitle'>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
            ut labore et dolore magna aliqua.
          </span>
          <form onSubmit={handleSubmit} noValidate>
            <div className='inputs'>
              <div>
                <input type='text'
                  placeholder='Nombre'
                  onChange={handleChange}
                  value={values.name || ''}
                  name='name'
                  className={errors.name ? 'error' : ''}
                  required />
                  {errors.name && (
                    <span>{errors.name}</span>
                  )}
              </div>
              <div>
                <input type='email'
                  placeholder='Email'
                  onChange={handleChange}
                  value={values.email || ''}
                  name='email'
                  className={errors.email ? 'error' : ''}
                  required />
                  {errors.email && (
                    <span>{errors.email}</span>
                  )}
              </div>
              <div>
                <input type='text'
                  placeholder='Telefono'
                  onChange={handleChange}
                  value={values.phone || ''}
                  name='phone'
                  className={errors.phone ? 'error' : ''}
                  required />
                  {errors.phone && (
                    <span>{errors.phone}</span>
                  )}
              </div>
            </div>
            <div>
              <textarea placeholder='Escribe tu mensaje...'
                value={values.message || ''}
                className={errors.message ? 'error' : ''}
                name='message'
                onChange={handleChange}>
              </textarea>
              {errors.message && (
                <span>{errors.message}</span>
              )}
            </div>
            <button>Enviar</button>
          </form>
        </div>
        <div className='info'>
          <span className='title'>
            Otras vías de contacto
          </span>
          <div className='option'>
            <strong>Estamos ubicados en</strong>
            <span>
              <a href="https://goo.gl/maps/RuEZ6VfgCpwvgbpQA">
                <img src={location} />
                Calle Agusti Domingo 21bjs 2. 08980. Barcelona.
              </a>
            </span>
          </div>
          <div className='option'>
            <strong>Info de contacto</strong>
            <span>
              <a href='https://api.whatsapp.com/send?phone=+34648196309' title='Chateemos por whatsapp' target="_blank">
                <img src={whatsapp} />
                +34 648 196 309
              </a>
            </span>
            <span>
              <a href='mailto:info@selo.es' title='Envíanos un email' target="_blank">
                <img src={mail} />
                info@selo.es
              </a>
            </span>
          </div>
          <div className='option'>
            <strong>Nuestros horarios</strong>
            <span>
              <img className='clock' src={clock} />
              Lun-Sat: 8:00 - 19:00
            </span>
          </div>
        </div>
      </div>

    </div>
  )
};

export default App;
